import _ from "lodash";
import * as React from "react";
import * as Comp from "../../../../components";
import * as Forms from "../../../../forms";
import * as M from "../../../../models";
import { Api } from "../../../../services/Api";
import { ReactHelper } from "../../../../utils";

interface OwnProps {
    api: Api;
    eventId: number;
    formComponent: Comp.Validation.IComponentWithValidatedForm;
}

interface OwnState {
}

export class EventMediaEditor extends React.Component<OwnProps, OwnState> {

    private _fieldname = "media";

    public constructor(props: any) {
        super(props);
        this.state = {
        };
    }

    public render() {
        const label = this.props.formComponent.getFieldLabel(this._fieldname);
        const formModel = this.props.formComponent.getFormModelData<Forms.AdminEvent.SubEventData>();

        const media = formModel.media
            .map((x, i) => (
                <li key={i} className="list-builder-item" style={{ display: x.isDeleted ? "none" : "block" }}>
                <div className="list-builder-fields">
                    <Comp.Editors.FileUploaderField
                        formComponent={this.props.formComponent}
                        name={`${this._fieldname}[${i}].media`}
                        noFieldWrap
                        onClearFile={(file) => this.deleteFile(file)}
                        onUploadComplete={(upload) => console.log("upload compelte", upload)}
                        renderBrowse={(id, props) => (
                            <a href="#" id={id} onClick={(e) => { ReactHelper.emptyClick(e); }}>
                                <Comp.Generic.Icon icon="folder" /> {props.browseLabel || "Browse"}
                            </a>
                        )}
                        uploader={{
                            filters: {
                                max_file_size: "100mb",
                                mime_types: [
                                    { title: "Documents", extensions: "doc,docx,pdf,rtf,txt" },
                                    { title: "Images", extensions: "bmp,gif,jpg,jpeg,png" },
                                ],
                                prevent_duplicates: true,
                            },
                            multipart_params: {
                                eventId: this.props.eventId,
                            },
                            url: Api.endpoints.admin.event.upload.absoluteApiUrl(),
                        }}
                    />

                    <Comp.Editors.CheckboxField formComponent={this.props.formComponent} name={`${this._fieldname}[${i}].isFloorPlan`} noFieldWrap />
                </div>
                <a className="req remove-trigger" href="#" onClick={(e) => { ReactHelper.emptyClick(e); this.onDelete(x.index); }} title="Delete document">
                    <i className="fa fa-times"></i>
                </a>
            </li>));

        return <div>
        <Comp.Editors.FormField label={label} name={this._fieldname}>
            <ul className="list-builder">
                {media}
            </ul>
        </Comp.Editors.FormField>

        <Comp.Editors.FormField name="">
            <a href="#" onClick={(e) => { ReactHelper.emptyClick(e); this.onAdd(); }}>
                <i className="fa fa-plus"></i> Add document
            </a>
        </Comp.Editors.FormField>
    </div>;
    }

    private async deleteFile(file: M.Upload.MediaMin) {
        const qp = { queryParams: { guid: file.guid, deleteMedia: true }};
        return await this.props.api.delete(Api.endpoints.media.media, qp);
    }

    private onAdd() {
        const formModel = this.props.formComponent.getFormModelData<Forms.AdminEvent.SubEventData>();
        const defItem = { ...Forms.AdminEvent.DefaultEventMedia };

        formModel.media.push({
            ...defItem,
            index: formModel.media.length,
        });

        this.props.formComponent.updateFormModelData(formModel);
    }

    private onDelete(idx: number) {
        const formModel = this.props.formComponent.getFormModelData<Forms.AdminEvent.SubEventData>();
        const item = _.find(formModel.media, (x, i) => x.index === idx);

        if (item) {
            item.isDeleted = true;
            this.props.formComponent.updateFormModelData(formModel);
        }
    }
}



// WEBPACK FOOTER //
// ./src/containers/adminEvent/editCalendar/components/EventMediaEditor.tsx